<template>
  <v-dialog
    v-model="modelValue"
    :max-width="width"
    :persistent="persistent"
    :fullscreen="fullscreen"
  >
    <v-card class="card" :color="backgroundColor">
      <div v-if="!hideHeader" class="header d-flex flex-column mb-4">
        <div class="d-flex">
          <slot name="title">
            <div>
              <div class="text-h6">
                <span v-html="title" />
              </div>

              <div v-if="subtitle" class="text-body-2 neutral8--text">
                <span v-html="subtitle" />
              </div>
            </div>
          </slot>

          <v-spacer />

          <v-btn :disabled="loading" icon small @click="handleAction('cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="content">
        <slot></slot>
      </div>

      <slot v-if="!hideFooter" name="footer">
        <div class="footer d-flex mt-6">
          <v-spacer />

          <v-btn
            v-for="(item, i) in footerButtons"
            class="btn"
            :color="item.color"
            :loading="loading"
            :disabled="item.disabled"
            :plain="item.plain"
            :key="i"
            @click="handleAction(item.action)"
          >
            <span :class="item.textClass"> {{ item.label }} </span>
          </v-btn>
        </div>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CustomDialog",

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      default: "",
    },

    subtitle: {
      type: String,
      default: "",
    },

    width: {
      type: [String, Number],
      default: "600",
    },

    footerButtons: {
      type: Array,
      default: () => [
        {
          label: "Cancelar",
          color: "white",
          plain: true,
          action: "cancel",
        },
        {
          label: "Confirmar",
          color: "primary",
          action: "submit",
        },
      ],
    },

    hideHeader: {
      type: Boolean,
      default: false,
    },

    hideFooter: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    persistent: {
      type: Boolean,
      default: true,
    },

    backgroundColor: {
      type: String,
      default: "neutral1",
    },

    fullscreen: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    modelValue(val) {
      if (val) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
  },

  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update:value", newValue);
      },
    },
  },

  methods: {
    handleAction(action) {
      this.$emit(action);
    },

    handleChangeModel(event) {
      this.$emit("update:value", event);
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
